import { CORE_SERVER, IMAGE_ID_URL } from "../config";
import { UploadedImage } from "../types/wizard";

function generateRandomId() {
  const min = 1000000;
  const max = 999999999; // max length = 9
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export const uploadFile = async (file: File): Promise<{ success: boolean; imageId?: string, imageData?: UploadedImage }> => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('Model', JSON.stringify({
    config: 'Stahls',
    ident: {
      superuser: false,
      sessionid: 'dc852e74-d3f0-42e8-95eb-4f3dbc6c16cc',
    },
  }));

  try {
    const response = await fetch(`${CORE_SERVER}/core2/userfiles/upload`, {
      method: 'POST',
      body: formData,
    });

    const json = await response.json();

    if (!json.Success || !json.Model?.Id) {
      throw new Error(json.Error || 'Failed to upload image to server.');
    }

    // TODO: Validate if we can use this generated image data from this point
    const uploadedImage: UploadedImage = {
      id: generateRandomId(),
      contentGuid: crypto.randomUUID(),
      url: IMAGE_ID_URL.replace("imageId", json.Model.Id),
      title: file.name,
    };

    return {
      success: true,
      imageId: json.Model.Id,
      imageData: uploadedImage,
    };
  } catch (error) {
    console.error('Error uploading file:', error);
    return { success: false };
  }
};
